import React, { useEffect, useState } from 'react';
import { Formik, Field, Form, ErrorMessage} from 'formik';
import Navbar from './Navbar';
import { Auth } from '@aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import LookupComponent from './LookupComponent';
import '@fortawesome/fontawesome-free/css/all.css';

const FindRecord = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [responseData, setResponseData] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [link, setLink] = useState('');
    const[linkText, setLinkText] = useState('');
    const[identifier, setIdentifier] = useState('');
    const navigate = useNavigate();
    const [idToken, setIdToken] = useState('');
  
    useEffect(() => {
        checkLogin();
    }, []);

    async function checkLogin() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            setIdToken(user.signInUserSession.idToken.jwtToken);
            setIsLoggedIn(true);
            
         } catch {
            console.log('in queryexportform: User not signed in');
            setIsLoggedIn(false);
            navigate('/login');
        }
    }
  
  
    useEffect(() => {
        
        if (isLoggedIn){
            console.log('Logged in');
            setLink('/logout');
            setLinkText('Logout');    
        }else{
            console.log('Not logged in');
            setLink('/login');
            setLinkText('Login');   

        }
    }, [isLoggedIn]);


    const handleSubmit = (values, {resetForm}) => {
        
        console.log('in handleSubmit');
        setIsLoading(true);

        setResponseData([]);
        console.log('identifier: ' + identifier)

        const payload = {
          
            identifier: identifier,
     
        };
        
        const apiUrl = 'https://1qk0vhgbua.execute-api.ap-southeast-1.amazonaws.com/prod/find';

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': '70pP5oMTgE9IlNLym0zGN8YTNamYIr4U7xxOy4Jq',
                'Authorization': 'Bearer ' + idToken
            },
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
            // console.log('ciam: ' + data['changi account']['airport_pass_expiry'])
            // console.log('cr: ' + data['changi rewards']['airport_pass_expiry'])
            // console.log('database: ' + data['database']['ddb_pass_expiry'])

            // if (data['changi account']['airport_pass_expiry'] !== null){
            //     data['changi account']['airport_pass_expiry'] = new Date(data['changi account']['airport_pass_expiry']).toLocaleDateString();
            // }

            // if (data['changi rewards']['airport_pass_expiry'] !== null){
            //     data['changi rewards']['airport_pass_expiry'] = new Date(data['changi rewards']['airport_pass_expiry']).toLocaleDateString();
            // }

            // if (data['database']['ddb_pass_expiry'] !== null || data['database']['ddb_pass_expiry'] === undefined){
            //     data['database']['ddb_pass_expiry'] = new Date(data['database']['ddb_pass_expiry']).toLocaleDateString();
            // }
            //console.log(data);
            setResponseData(data);


            setIsLoading(false);
        })
        .catch((error) => {
            console.error('Error:', error);
            setIsLoading(false);
        });

    };

    return (
        <Formik
            initialValues={{
                identifier: '',
            }}
            onSubmit={handleSubmit}

        >
                

        {({ setFieldValue, values, resetForm }) => (
        <Form>

        <div className="flex-container-1">         
            <div className="upload-container">
                <Navbar link={link} linkText={linkText}/>
                {/*}
                    <a className="loginout-button-style" href={link}>{linkText}</a> 
                */}
     
                <div className="upload-contents-container">

                    <div className="upload-text-container">
                        <i className="fa-solid fa-magnifying-glass fa-2xl"></i><h2>Lookup a Submission</h2>
                        <p>Query for a submission using CR Card Number, UID or Hashed Email Address</p>
                    </div>

                    <div className="upload-text-container">
                        <label>CR Card Number, UID or Hashed Email Address</label>
                        <div>
                            <input 
                                value={identifier}
                                onChange={(event) => setIdentifier(event.target.value)}
                                type="text"
                            />
                    
                            <ErrorMessage name="identifier" component="div" className="error-message"/>
                        </div>
                    </div>

                    <div>
                        {isLoading && (
                            <div className="spinner">
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                            </div>
                        )}
                    </div>

                    <div className="upload-text-container">
                        <div className="button-container">
                            <button className="upload-button" type="submit">Lookup</button>
                        </div>
                    </div>
                            <LookupComponent data={responseData} />

                
                </div>
            </div>
        </div>        
                           
                
          </Form>
        )}
        </Formik>
    );
};

export default FindRecord;
